import styled from 'styled-components';

export const ActionsContainer = styled.div`
  display: inline;
  margin: 0px 0px 0px 0px;
  > * {
    margin: 0px 0px 0px 0px;
  }
`;
